<template>
    <div style="width: 98%;" class="mx-2 mx-md-auto">

        <b-modal id="modal-comments" scrollable size="md" hide-footer :title="'COMMENTS FOR ('+item_comments_invoice_id+')'">
            <ItemComments :viewdata="{invoice_id: item_comments_invoice_id, itemid: item_comments_itemid, username: packet.userDetails.username}" />
        </b-modal>

        <div style="width: 100%;">
            <div>
                <div>
                    <InvoiceSearcher v-on:find-item="load_items" />
                </div>
            </div>
        </div>


        <div style="width: 100%; max-height: 800px; overflow-y: scroll; padding: 5px; min-height: 200px;">
            <div>
                <div v-if="items_being_loaded == true">
                    <loading
                        :active="true"
                        :can-cancel="false"
                        :is-full-page="false">
                    </loading>
                </div>
                <div v-else>
                    <div v-if="Object.keys(invoice).length > 0">

                        <b-container class="bv-example-row" style="margin: 0px; padding: 5px;">
                            <b-row>
                                <b-col style="padding: 2px" cols="12" md="6" lg="3">
                                    <b-input-group prepend="INVOICE #" class="mt-3" style="margin: 2px; padding: 0px;">
                                        <b-form-input style="font-weight: bold;" :disabled="true" :value="invoice.invoice_id"></b-form-input>
                                    </b-input-group>
                                </b-col>

                                <b-col style="padding: 2px" cols="12" md="6" lg="3">
                                    <b-input-group prepend="DATE" class="mt-3" style="margin: 2px; padding: 0px;">
                                        <b-form-input style="font-weight: bold;" :disabled="true" :value="invoice.ts"></b-form-input>
                                    </b-input-group>
                                </b-col>

                                <b-col style="padding: 2px" cols="12" md="6" lg="4">
                                    <b-input-group prepend="SOLD FROM" class="mt-3" style="margin: 2px; padding: 0px;">
                                        <b-form-input style="font-weight: bold;" :disabled="true" :value="packet.locsubsdict[invoice.location_id + '|' + invoice.sublocation_id]"></b-form-input>
                                    </b-input-group>
                                </b-col>

                                <b-col style="padding: 2px" cols="12" md="6" lg="3">
                                    <b-input-group prepend="CUSTOMER" class="mt-3" style="margin: 3px; padding: 0px;">
                                        <b-form-input style="font-weight: bold;" :disabled="true" :value="(invoice.customer.fullname || '' ).toUpperCase()"></b-form-input>
                                    </b-input-group>
                                </b-col>

                            </b-row>
                        </b-container>


                        <div style="margin-top: 10px; overflow-x: auto;">
                            <table style="width: 100%;">

                                <thead>
                                    <tr>
                                        <th style="min-width: 100px;" class="srr">
                                            GROUP
                                        </th>

                                        <th style="min-width: 100px;" class="srr">
                                            PRODUCT
                                        </th>

                                        <th style="min-width: 100px;" class="srr">
                                            ORDER TYPE
                                        </th>

                                        <th style="min-width: 30px;" class="srr">
                                            QTY
                                        </th>

                                        <th style="min-width: 200px;" class="srr">
                                            ITEM PICK FROM
                                        </th>

                                        <th style="min-width: 200px;" class="srr">
                                            DROP LOCATION
                                        </th>

                                        <th style="min-width: 200px;" class="srr">
                                            DELIVERY FROM
                                        </th>

                                        <th style="min-width: 100px;" class="srr">
                                            DELIVERY DATE
                                        </th>

                                        <th style="min-width: 150px;" class="srr">
                                            STATUS
                                        </th>

                                        <th style="min-width: 100px;" class="srr">
                                            COMMENTS
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="item,idx in invoice.items" v-bind:key="idx">
                                        <td class="srrv">
                                            <div v-if="item.parent_product_name">
                                                <div>{{item.parent_product_name}}</div>
                                                <div>({{item.parent_product_sku}})</div>
                                            </div>
                                            <div v-else>

                                            </div>
                                        </td>

                                        <td class="srrv">
                                            <div>{{item.product_name}}</div>
                                            <div>({{item.product_sku}})</div>
                                        </td>

                                        <td class="srrv">
                                            {{order_type_map[item.order_type]}}
                                        </td>

                                        <td class="srrv">
                                            {{item.quantity}}
                                        </td>

                                           <td class="srrv">
                                            {{ packet.locsubsdict[item.original_locsub ? item.original_locsub : item.locsub] }}
                                        </td>

                                        <td class="srrv">
                                            {{packet.locsubsdict[item.drop_locsub]}}
                                        </td>

                                        <td class="srrv">
                                            {{packet.locsubsdict[item.ship_locsub]}}
                                        </td>


                                        <td class="srrv">
                                            {{item.delivery_date}}
                                        </td>

                                        <td class="srrv">
                                            <b-form-select size="sm" :options="states" v-model="item.state" :disabled="item.locsub === '46|122' || disabled" v-on:change="update_invoice_item_state(item)"></b-form-select >
                                        </td>

                                        <td class="srrv">
                                            <button  @click="show_comments(item)">VIEW
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>


<script>
    import DatePicker from 'vue2-datepicker';
    import moment from 'moment'

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    import ItemComments from '@/components/importables/ItemComments'
    import InvoiceSearcher from "@/components/importables/InvoiceSearcher"

    import mappings from '@/utilities/mappings'

    export default {
        name: "OrderShipment",
        components: {flatPickr, Loading, ItemComments, DatePicker, InvoiceSearcher},
        data: function(){
            let out = {
                invoice: {},
                items_being_loaded: null,
                item_comments_invoice_id: null,
                item_comments_itemid: null,
                order_type_map: {
                    "home_delivery": "HOME DEL",
                    "store_pickup": "STRE PICK",
                    "customer_takes": "TAKE HOME"
                },
                disabled: true,
            }
            out.states = mappings.states.map(function(d){ d.disabled = false; return d;});
            return out;

        },
        methods: {
            load_items: function(e){
                let invoice_id = e.invoice_id;
                let path = "/api/sales/get_items_for_invoice/"
                let that = this;

                let data = {invoice_id: invoice_id}
                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        if (response.data.result.length >0){
                            that.invoice = response.data.result[0];
                        }
                    }
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading invoice.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                Requestor.postAsyncP(path, data, this, s, f);
            },

            allowed: function(item){
                let status = true
                let allowed_item = this.allowed_item(item);
                let filtered_location = this.filtered_location(item);
                let filtered_pickup_truck = this.filtered_pickup_truck(item);
                let filtered_delivery_truck = this.filtered_delivery_truck(item);

                if (allowed_item && filtered_location && filtered_pickup_truck && filtered_delivery_truck){
                    status = true
                }
                else {
                    status = false
                }
                return status

            },
            allowed_item: function(item){
                let status = true;
                let userrole = this.packet.userDetails.userrole;
                let item_location_id = item.drop_location;

                if (userrole == "admin" || userrole == "officeuser" || userrole == "officemanager") {
                    status = true;
                }
                else {
                    if (this.packet.userDetails.properties.location_id) {

                        let location_id = parseInt(this.packet.userDetails.properties.location_id);
                        if (location_id == item.item_location_id){
                            status = true
                        }
                        else {
                            status = false
                        }
                    }
                    else {
                        status = false;
                    }
                }
                return status
            },


            filtered_location: function(item){
                let status = true;
                if (this.picked_location_id) {
                    if (item.drop_location == this.picked_location_id){
                        status = true;
                    }
                    else {
                        status = false;
                    }
                }
                console.log(item.drop_location, this.picked_location_id, status)
                return status
            },

            filtered_pickup_truck: function(item){
                let status = true;
                if (this.picked_pickup_truck) {
                    if (item.pickup_truck == this.picked_pickup_truck){
                        status = true;
                    }
                    else {
                        status = false;
                    }
                }
                return status
            },

            filtered_delivery_truck: function(item){
                let status = true;
                if (this.picked_delivery_truck) {
                    if (item.truck == this.picked_delivery_truck){
                        status = true;
                    }
                    else {
                        status = false;
                    }
                }
                return status
            },

            show_comments: function(item){
                this.item_comments_invoice_id = item.invoice_id;
                this.item_comments_itemid= item.itemid;
                this.$bvModal.show("modal-comments");
            },
            update_invoice_item_state: function(item){
                let path = "/api/sales/update_invoice_item_state/"
                let that = this;

                if (item.state != 1 && item.old_state == 1){
                    that.$bvToast.toast(
                        "CANNOT CHANGE STATE ONCE DELIVERED.",
                        {title: "NOT ALLOWED", autoHideDelay: 1500, variant:"dark"}
                    );
                    return
                }

                let data = {invoice_id: item.invoice_id, itemid: item.itemid, state: item.state, changed_by: this.packet.userDetails.username, product_sku: item.product_sku, quantity: item.quantity}

                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Success updating item state.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );

                    }
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error updating item state.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                Requestor.postAsync(path, data, s, f);
            },
            // get_dates: function(){
            //     let path = ""
            //     let that = this;
            //     if (this.type == 'incoming'){
            //         path = "/api/sales/get_incoming_items_dates/"
            //     }
            //     else if(this.type == 'outgoing') {
            //         path = "/api/sales/get_outgoing_items_dates/"
            //     }

            //     if (!path){
            //         return
            //     }
            //     let data = {locsub: this.locsub}

            //     let s = function(response) {
            //         if (response.data.result){

            //             that.dates = response.data.result;
            //         }
            //         else {
            //             that.$bvToast.toast(
            //                 response.data.error,
            //                 {title: "Error", autoHideDelay: 1500, variant:"warning"}
            //             );
            //         }
            //         that.dates_being_loaded = false;
            //     }

            //     let f = function(error) {
            //         console.log(error)
            //         that.$bvToast.toast(
            //             "Error retrieving dates for the incoming items.",
            //             {title: "Error", autoHideDelay: 1500, variant:"danger"}
            //         );
            //         that.dates_being_loaded = false;
            //     }
            //     this.items = [];
            //     this.dates_being_loaded = true;
            //     this.active_date = null;
            //     Requestor.getSync(path, data, s, f);
            // },
            get_items_for_date: function(date){
                this.active_date = date.date;

                let that = this;
                let path = ""
                if (this.type == 'incoming'){
                    path = "/api/sales/get_incoming_items/"
                }
                else {
                    path = "/api/sales/get_outgoing_items/"
                }

                if (!path){
                    return
                }
                let data = {locsub: this.locsub, date: date.date}
                let s = function(response) {
                    if (response.data.result){
                        that.items = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }

                    that.items_being_loaded = false;
                    that.get_batch_comments();
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error fetching items for the date.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }
                this.items = [];
                this.items_being_loaded = true;
                Requestor.getSync(path, data, s, f);
            },
            get_batch_comments: function(){
                // let items = this.items.map(function(d){
                //     return {invoice_id: d.invoice_id, itemid: d.itemid}
                // })

                let items = [];
                for (var i =0; i<this.items.length; i++){
                    for (var j=0; j<this.items[i].items.length; j++){
                        items.push(
                            {
                                invoice_id: this.items[i].items[j].invoice_id,
                                itemid: this.items[i].items[j].itemid,
                            }
                        )
                    }
                }
                let path = "/api/sales/get_batch_comments/"
                let data = {items: items};
                let that = this;
                let s = function(response){
                    if (response.data.result){
                        //that.items = response.data.result;
                        //console.log(response.data.result);
                        let comments = response.data.result;
                        if (comments.length > 0){
                            that.comments_dict = Object.assign({}, ...comments.map((x) => ({[x.invoice_id+'|'+x.itemid]: x.n_comments})));
                            console.log(that.comments_dict);
                        }

                    }
                    else {
                        console.log(response.data.error)
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                }

                let f = function(error){
                    that.$bvToast.toast(
                        "Error loading comments.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }

                Requestor.postAsync(path, data, s, f);
            },
            fetch_init2: function(d){
                let path = "/api/sales/get_incoming_items_for_date_range/"
                let that = this;
                let data = {date_range: this.date_range, drop_location: this.drop_location};

                if (!data.drop_location){
                    this.$vex.dialog.alert({
                        message: "PICK AN INCOMING LOCATION"
                    });
                    return
                }

                if (data.date_range.length < 2){
                    this.$vex.dialog.alert({
                        message: "PICK A PROPER DATE RANGE"
                    });
                    return
                }
                let s = function(response) {
                    if (response.data.result){
                        that.items = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading incoming items.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }

                this.items_being_loaded = true;
                this.items = [];
                Requestor.postSync(path, data, s, f);
            },
            get_incoming_items_for_date: function(){
                let path = "/api/sales/get_incoming_items_for_date/"
                let that = this;
                let data = {date: this.picked_date};
                let s = function(response) {
                    if (response.data.result){
                        that.items = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading incoming items.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }

                this.items_being_loaded = true;
                this.items = [];
                Requestor.postSync(path, data, s, f);
            },
            get_incoming_dates_for_year_month: function(){
                let path = "/api/sales/get_incoming_dates_for_year_month/"
                let that = this;
                let data = {year: this.year, month: this.month};
                if (this.packet.userDetails.properties.location_id){
                    data.location_id = this.packet.userDetails.properties.location_id;
                }
                let s = function(response) {
                    if (response.data.result){
                        that.dates = response.data.result;
                        that.dates = that.dates.map(function(d){
                            return {value: d.date, text: d.date + ' ('+d.nitems+')' }
                        });
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.dates_being_loaded = false;
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading incoming dates.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.dates_being_loaded = false;
                }

                this.dates = [];
                this.items = [];
                this.picked_date = null;
                this.picked_location = null;
                Requestor.postAsync(path, data, s, f);
            },
            fetch_prereqs: function(){
            },
            fetch: function(type){

                this.type = type;
                this.items = []
                this.dates = []
                this.active_date = null;
                //this.locations = [];
                this.locsub = null;
                //this.get_dates()
            },
            sortby: function(key,mapper){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items,key,mapper)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items,key,mapper)
                }
                this.sort_asc = !this.sort_asc;
            },
            set_dates: function(value){
                let start = null;
                let end = null;

                if(value == 'today') {
                    start = moment().format("MM-DD-YYYY");
                    end = moment().format("MM-DD-YYYY");

                }
                if(value == 'yesterday') {
                    start = moment().add(-1, 'days').format("MM-DD-YYYY");
                    end = moment().add(-1, 'days').format("MM-DD-YYYY");
                }
                if(value == 'this_week') {
                    start = moment().startOf('week').format("MM-DD-YYYY");
                    end = moment().endOf('week').format("MM-DD-YYYY");
                }
                if(value == 'last_week') {
                    start = moment().subtract(1, 'weeks').startOf('week').format("MM-DD-YYYY");
                    end = moment().subtract(1, 'weeks').endOf('week').format("MM-DD-YYYY");
                }
                if(value == 'this_month') {
                    start = moment().startOf('month').format("MM-DD-YYYY");
                    end = moment().endOf('month').format("MM-DD-YYYY");
                }
                if(value == 'last_month') {
                    start = moment().subtract(1, 'months').startOf('month').format("MM-DD-YYYY");
                    end = moment().subtract(1, 'months').endOf('month').format("MM-DD-YYYY");
                }



                if (start && end) {
                    this.date_range = [start , end]
                    this.picked_date_range = value;

                    //this.fetch_init()
                }
            },
            get_locations: function(){
                let output = [
                    {value: null, text: "PICK LOCATION", disabled: true}
                ];
                let user_location = this.packet.userDetails.location_id;
                if (+user_location){
                    output = this.packet.locations.filter(function(d){return d.value == user_location});
                }
                else {
                    output = output.concat(this.packet.locations.filter(function(d){return d.text != 'All'}))
                }

                return output
            }


        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.trucks = this.packet.trucks;


            if (["admin", "officeuser", "officemanager"].includes(this.packet.userDetails.userrole)){
                this.disabled = false;
            }
            else {
                this.disabled = true;
            }
            //let that = this;
            // this.locsubs = this.packet.locations.filter(function(d){
            //     // if(that.packet.userDetails.userrole == "admin" || that.packet.userDetails.userrole == "warehouseuser" || that.packet.userDetails.userrole == "warehousemanager" ){
            //     //     return d
            //     // }
            //     // else {
            //     //     return that.packet.userDetails.properties.location_id == parseInt(d.value.split("|")[0]);
            //     // }


            //     if (that.packet.userDetails.properties.location_id != null){
            //         return
            //             (
            //             (that.packet.userDetails.properties.location_id == parseInt(d.value.split("|")[0]))
            //             ||
            //             d.is_main_warehouse == true
            //             )
            //     }
            //     else {
            //         if (that.packet.userDetails.userrole == "admin"){
            //             return d
            //         }
            //         else {
            //             return d.is_main_warehouse == true
            //         }
            //     }

            // });


            // if (this.packet.userDetails.userrole == "admin"){
            //     this.locsubs.splice(0, 0, {value: 'all', text: 'ALL'});
            // }
        }

    }

</script>

<style scoped>

    .srr {
        font-size: 12px;
        text-align: center;
        background: #efefef;
        border: 1px solid #010101;
    }

    .srrv {
        font-size: 12px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
        padding: 5px;
    }

</style>



// WEBPACK FOOTER //
// src/components/IncomingOutGoing/OrderShipment.vue